import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailSettingService } from '@services/email-setting.service';
import { LoaderService } from '@services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-send-test-mail',
  templateUrl: './send-test-mail.component.html',
  styleUrl: './send-test-mail.component.scss'
})
export class SendTestMailComponent implements OnInit {
  sendMail: FormGroup;
  public isAuthLoadingTest = false;
  isLoadingTest$: Observable<boolean>;
  constructor(
    private emailSettingService: EmailSettingService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private loaderService: LoaderService

  ) {
    this.isLoadingTest$ = this.loaderService.isLoading$;
  }
  ngOnInit() {
    this.sendMail = this.formBuilder.group({
      sendEmail: [null, [Validators.required, Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )]],

      // password and confirm password only required in add mode

    })
  }
  onSubmitsendMail() {
    this.loaderService.showLoader();
    this.isAuthLoadingTest = true;
    this.emailSettingService.sendTestMail(this.sendMail.value.sendEmail)
      .subscribe({
        next: (response: any) => {
          setTimeout(() => {
            this.isAuthLoadingTest = false;
            this.loaderService.hideLoader();
            this.toastr.error("Email Sent");
          }, 2000);
        },
        error: (error) => {
          setTimeout(() => {
            this.isAuthLoadingTest = false;
            this.loaderService.hideLoader();
            this.toastr.error("Email Not Sent");
          }, 2000);
        }
      });
  }

}
